module.exports = __webpack_public_path__ + "static/media/productdevelopment.b2a42882.avif";